module.exports = __webpack_public_path__ + "img/404.98617637.png";